import { useQuery } from 'react-query';
import { appendQueryParamIfNotEmpty, generateQueryKey } from '../../../constants/hookConstants';
import { dataFetch, DIGGER_API_SUFFIX } from '../../../axios/customAxios';

export interface TokenSessionsQueryParams {
  search?: string;
  rows: number;
  page: number;
}

const normalizeTokenResponse = (res: any) => {
  const payload = res?.data;
  if (payload?.data?.data && payload?.data?.meta) return payload.data;
  return payload;
};

const useGetTokenSessions = (identifier: string, params: TokenSessionsQueryParams) => {
  const queryParams = new URLSearchParams();
  appendQueryParamIfNotEmpty(queryParams, 'search', params.search?.trim?.() ?? params.search ?? '');
  appendQueryParamIfNotEmpty(queryParams, 'rows', String(params.rows));
  appendQueryParamIfNotEmpty(queryParams, 'page', String(params.page));

  const queryKey = generateQueryKey(identifier, queryParams);
  return useQuery(
    [`auth_tokens_sessions_${queryKey}`],
    () => dataFetch.get(`${DIGGER_API_SUFFIX}auth/tokens/session?${queryParams}`).then(normalizeTokenResponse),
  );
};

export default useGetTokenSessions;
